import { render, staticRenderFns } from "./ContractLoader.vue?vue&type=template&id=69fec20b&scoped=true&"
import script from "./ContractLoader.vue?vue&type=script&lang=ts&"
export * from "./ContractLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ContractLoader.vue?vue&type=style&index=0&id=69fec20b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fec20b",
  null
  
)

export default component.exports